export default "__VITE_ASSET__B4Uz$N68__"